import SelectedStoreBase from "../../../../common/state/modules/selectedStoreBase";
import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import Organization from "../../../../common/models/organization";
import User from "../../../../common/models/user";
import Certificate from "../../models/certificate";
import PageCertificateElement from "../../models/pageCertificateElement";
import CertificateDynamicInput from "../../models/certificateDynamicInput";
import CertificateFoundationLayer from "../../models/certificateFoundationLayer";
import BaseCertificateElement from "../../models/baseCertificateElement";
import AdaptiveLayoutSection from "../../models/adaptiveLayoutSection";

export default class Selected extends SelectedStoreBase {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static certificate = new SingleSelectedProperty('certificate', () => Certificate);
  static certificateElement = new SingleSelectedProperty('certificateElement', () => BaseCertificateElement);
  static organization = new SingleSelectedProperty('organization', () => Organization);
  static currentPage = new SingleSelectedProperty('currentPage', () => PageCertificateElement);
  static currentSection = new SingleSelectedProperty('currentSection', () => AdaptiveLayoutSection);
  static dynamicInput = new SingleSelectedProperty('dynamicInput', () => CertificateDynamicInput);
  static foundationLayer = new SingleSelectedProperty('foundationLayer', () => CertificateFoundationLayer);
}